/**
 * eslint-disable @angular-eslint/component-max-inline-declarations
 *
 * @format
 */

/** @format */

import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  model,
  NO_ERRORS_SCHEMA,
  output,
  signal,
  inject,
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  homefieldIconChevronDownOutline,
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
} from '@dsg-tech/homefield-angular-icons';

const TRANSITION_TIME = 325;
@Component({
  selector: 'common-accordion',
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [HomefieldIconLibraryModule],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          height: '*',
          opacity: 1,
        }),
      ),
      state(
        'closed',
        style({
          height: '0',
          opacity: 0,
          display: 'none',
        }),
      ),
      transition('open => closed', [animate(`${TRANSITION_TIME}ms cubic-bezier(0.4, 0, 0.2, 1)`)]),
      transition('closed => open', [animate(`${TRANSITION_TIME}ms cubic-bezier(0.4, 0, 0.2, 1)`)]),
    ]),
  ],
})
export class AccordionComponent {
  private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

  readonly isArrowIconCentered = input(false);
  readonly arrowIconSmall = input<boolean>(false);
  readonly isDisabled = input<boolean>(false);
  readonly isTitleCentered = input(true);
  readonly hideHeaderLine = input<boolean>(false);
  readonly hideMobileHeaderLine = input(false);
  readonly hideArrowIcon = input<boolean>(false);
  readonly hideHeading = input(false);

  readonly isCollapsed = model(false);

  readonly accordionClicked = output<boolean>();

  private readonly _animatingCollapse = signal(false);

  readonly hideBodyAndFooter = computed(() => this.isCollapsed() && !this._animatingCollapse());
  readonly altText = computed(() =>
    this.isCollapsed() ? 'Expand this panel.' : 'Collapse this panel.',
  );

  constructor() {
    this.homefieldIconsLibraryService.registerIcons([homefieldIconChevronDownOutline]);
  }

  /**
   * @description
   * Event handler for when the accordion title is clicked and handles the expand / collapse of the body / footer
   */
  public expandCollapse($event: Event) {
    if (this.isDisabled()) {
      $event.preventDefault();
    } else {
      // Whether the accordion will become collapsed
      const newCollapsedState = !this.isCollapsed();

      if (newCollapsedState) {
        this._animatingCollapse.set(true);
        setTimeout(() => {
          this._animatingCollapse.set(false);
        }, TRANSITION_TIME);
      } else {
        this._animatingCollapse.set(false);
      }

      this.isCollapsed.set(newCollapsedState);
      this.accordionClicked.emit(newCollapsedState);
    }
  }
}
